import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DASHBOARDS_TEMPLATE_ROUTE, generateRoutePath } from '@fullstory/routes';
import { Box, Button } from '@fullstory/components';
import { useDashboardTemplateMap, DashboardTemplateIds } from '@fullstory/template-gallery-model';
import { useSelector } from 'react-redux';
import { fullstorySelectors } from '@fullstory/redux';
import { FROM_CONTEXT_TEMPLATE_QUERY_PARAM } from './useDXObjectViewedAnalyticsEvent';
import { createPath } from 'history';

export const useReturnToTemplate = () => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const history = useHistory();
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const templateId = queryParams.get(FROM_CONTEXT_TEMPLATE_QUERY_PARAM);
  const dashboardTemplateMap = useDashboardTemplateMap();

  const template = templateId ? dashboardTemplateMap.get(templateId as DashboardTemplateIds) : null;

  if (!templateId || !template) return null;

  const pathname = generateRoutePath(DASHBOARDS_TEMPLATE_ROUTE, { orgId, id: templateId });
  const path = createPath({ pathname, search: queryParams.toString() });
  return (
    <Box data-component="ReturnToTemplateButton" flexShrink={0}>
      <Button iconLeft="arrow-left" variant="fill-secondary" onClick={() => history.push(path)}>
        {template.title}
      </Button>
    </Box>
  );
};
